import React from 'react';
import { ShieldAlert } from 'lucide-react';

export const NonFdicNotice = ({ light = false, className = '' }) => (
  <div
    data-testid="non-fdic-notice"
    className={`flex items-start gap-2 rounded-lg px-4 py-3 text-xs ${light ? 'bg-amber-50 text-amber-900 border border-amber-200' : 'bg-amber-500/10 text-amber-300 border border-amber-500/30'} ${className}`}
  >
    <ShieldAlert className="w-4 h-4 shrink-0 mt-0.5" />
    <p>
      <strong>NOT FDIC INSURED &middot; SUBJECT TO LOSS.</strong>{' '}
      BETH balances, credit lines and crypto checks are not insured by the FDIC or any government agency and may lose value, including loss of principal.
    </p>
  </div>
);
